import React from 'react';
import moment from 'moment';

const calendarFormats = {
  sameDay: '[Today]',
  nextDay: '[Tomorrow]',
  lastDay: '[Yesterday]',
  lastWeek: '[Last week]',
  sameElse: 'DD MMM YYYY',
};

const formatDate = (date) => {
  return moment(date).calendar(null, calendarFormats);
};

const LastJob = ({ cellData: carrier }) => {
  if (!carrier) return;

  const { last_journey_datetime: date } = carrier;

  return <div>{(date && formatDate(date)) || ''}</div>;
};

export default LastJob;
